import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
const SvgCloud = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 16 16" role="img" ref={ref} {...props}><path fill="currentColor" d="M13.14 13.14H3.43a3.43 3.43 0 1 1 0-6.85h.16a4.56 4.56 0 0 1 9 1.13h.57a2.86 2.86 0 1 1 0 5.71z" /></svg>;
const ForwardRef = forwardRef(SvgCloud);
export default ForwardRef;